import type { BoxProps } from '@hover/blueprint';
import { Panel } from '@hover/blueprint';
import React, { useEffect } from 'react';

import type { Menu } from 'src/modules/designStudio/constants';
import { TOAST_PORTAL_ELEMENT_ID } from 'src/shared/providers/Toaster';

import { AnimatedContainer } from './components/AnimatedContainer';

type SlideUpCardProps = {
  closeMenu?: () => void;
  disabled?: boolean;
  onHeightChange?: (currentHeight: number) => void;
  closeable?: boolean;
  menu: Menu | null;
  containerRef: React.RefObject<HTMLElement> | null;
} & BoxProps;

const SlideUpCard = ({
  children,
  closeMenu,
  disabled,
  onHeightChange,
  closeable,
  containerRef,
  menu,
  ...props
}: SlideUpCardProps) => {
  useEffect(() => {
    const toast = document.getElementById(TOAST_PORTAL_ELEMENT_ID);
    if (toast) document.querySelector('#toast-container')?.prepend(toast);

    return () => {
      if (toast) {
        document.querySelector('#toolbar')?.prepend(toast);
      }
    };
  }, []);

  return (
    <AnimatedContainer
      closeMenu={closeMenu}
      closeable={closeable}
      disabled={disabled}
      onHeightChange={onHeightChange}
    >
      <div id="toast-container" />
      <Panel
        borderRadius="12px 12px 0 0"
        bottom="0"
        boxShadow="dark-lg"
        height="100%"
        overflowY="auto"
        paddingTop={400}
        paddingX={400}
        width="100%"
        {...props}
      >
        {children}
      </Panel>
    </AnimatedContainer>
  );
};

export { SlideUpCard, SlideUpCardProps };
